// extracted by mini-css-extract-plugin
module.exports = {"NumericRangeFeature":"vv_a bhc_b bhc_ux"};